import React from "react";
import StyledPrincipalID from "./PrincipalID.styled";

const PrincipalID = ({ principal }: { principal: string }) => {
  const label = principal.toString();
  return (
    <StyledPrincipalID as="b" title={label}>
      {label.length > 10 ? `${label.slice(0, 8)}...` : label}
    </StyledPrincipalID>
  );
};

export default PrincipalID;
